import * as React from 'react';
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days';

import useMe from 'Shared/Hooks/useMe';
import customSessionStorage from 'Utils/customSessionStorage';

import { RootTopBannerProps } from '../../types';
import MembershipRenovationBanner from '../MembershipRenovationBanner';
import TopBanner from '../TopBanner';

const Banner: React.FC<RootTopBannerProps> = ({
  graphqlVariables,
  customBannerDataParser,
}) => {
  const { me } = useMe();
  const [
    canRenderMembershipRenovationBanner,
    setCanRenderMemberhipRenovationBanner,
  ] = React.useState(false);

  React.useEffect(() => {
    if (
      me &&
      me.membership &&
      ['null', 'true', '"true"'].includes(
        JSON.stringify(
          customSessionStorage.getItem(
            'RENOVATION_MEMBERSHIP_DIALOG__bannerVisibility',
          ),
        ),
      )
    ) {
      const THRESHOLD_REMAINING_DAYS = 30;
      const REMAINING_DAYS = differenceInCalendarDays(
        new Date(me.membership.expireDate),
        new Date(),
      );
      const isMembershipAutorenovationActive =
        me.membership.isSubscriptionCanceled;

      // Does the user membership has 30 days remaining or less?
      if (
        REMAINING_DAYS <= THRESHOLD_REMAINING_DAYS &&
        isMembershipAutorenovationActive
      ) {
        setCanRenderMemberhipRenovationBanner(true);
      }
    }
  }, [me]);

  return (
    <div>
      {canRenderMembershipRenovationBanner ? (
        <MembershipRenovationBanner />
      ) : (
        <TopBanner
          graphqlVariables={graphqlVariables}
          customBannerDataParser={customBannerDataParser}
        />
      )}
    </div>
  );
};

export default Banner;
